import { useState, useEffect, createContext, useContext } from "react";

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState({role:"guest"});
  return admin ? (
    <AdminContext.Provider value={{ admin, setAdmin }}>
      {children}
    </AdminContext.Provider>
  ) : (
    <div className="flex flex-col items-center justify-center h-screen bg-red-50 bg-opacity-50 dark:bg-red-50">
      <div
        className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
        role="status"
      ></div>
      <p className="mt-4 text-lg font-semibold text-gray-700 dark:text-gray-300">
        Loading ...
      </p>
    </div>
  );
};

export const useAdmin = () => {
  return useContext(AdminContext);
};
